<template>
  <svg viewBox="0 0 36 36" class="circular-chart">
    <path
      class="circle-bg"
      stroke-dasharray="100, 100"
      d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
    />

    <path
      class="circle"
      :stroke-dasharray="`${percentage}, 100`"
      d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
    />

    <text x="18" y="22.35" class="percentage">
      {{ innerText || percentage }}
    </text>
  </svg>
</template>

<script>
export default {
  name: 'CircleLoader',
  props: {
    innerText: {
      type: String,
      default: () => null,
    },
    percentage: {
      type: Number,
      default: () => 0,
    },
  },
};
</script>

<style scoped>
.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 250px;
}

.circle {
  stroke: #4cc790;
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
}

.percentage {
  fill: #666;
  font-family: sans-serif;
  font-size: 0.8em;
  text-anchor: middle;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>
